import { StepLabel } from '@mui/material';
import { useFormState, useFormActions, useScopedField } from '@ngt/forms-core';
import React, { FC, useCallback } from 'react';

interface IStepLabelCheckProps {
    onClick: () => void;
    label: string;
    index: number;
    setComplete: React.Dispatch<React.SetStateAction<Record<number, boolean>>>;
}

const StepLabelCheck: FC<IStepLabelCheckProps> = ({ onClick, label, index, setComplete}) => {
    const {state: {value: alreadyRegistered}} = useScopedField<boolean>("alreadyRegistered", {value: true});
    const {state: {value: staff}} = useScopedField<boolean>("staff", {value: true});
    const {state: {value: staffConfirmed}} = useScopedField<boolean>("staffConfirmed", {value: true});
    const {fields, errors} = useFormState({errors: true, fields: true})
    const {setTouched} = useFormActions();   

    const onNext = useCallback((e: React.MouseEvent) => {
        const hasErrors = fields.reduce((a, b) => {
            if(a)
                return a;
            return errors[b]?.length > 0;
        }, false);
        
        if (alreadyRegistered || (staff == true && staffConfirmed != true)) {
            return;
        }

        if (!hasErrors) {
            onClick();
        }
        else {
            onClick();
            setTouched((current) => {
                fields.forEach(path => {
                    current[path] = true;
                });
    
                return current;
            });

            document.querySelector('.error-normal')?.scrollIntoView({behavior: 'smooth', block: 'center'});
        }
    }, [errors, fields, index, setComplete, alreadyRegistered, onClick, staff, staffConfirmed]);

    return(
        <StepLabel 
            onClick={onNext}
        >
            {label}
        </StepLabel>
    )
}

export default StepLabelCheck;